import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class VerificareEvidentaService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private getEvidentaListUrl = this.basePath + environment.interop.indoc.verificareEvidenta.getVerificareEvidenta;
    private findEvidentaUrl = this.basePath + environment.interop.indoc.verificareEvidenta.findVerificareEvidenta;
    private deleteEvidentaUrl = this.basePath + environment.interop.indoc.verificareEvidenta.deleteVerificareEvidenta;

    constructor(private http: HttpClient) { }

    listVerificareEvidenta() {
        return this.http.get(this.getEvidentaListUrl, this.httpOptions);
    }

    getEvidenta(id: number) {
        return this.http.get(this.findEvidentaUrl + id, this.httpOptions);
    }

    deleteEvidenta(id: number) {
        return this.http.delete(this.deleteEvidentaUrl + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
